var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.327,
    height: 19.693,
    viewBox: "0 0 24.327 19.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(-436.457 -289.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M443.415,293.467h15.371a2,2,0,0,0,1.469-3.355,2.034,2.034,0,0,0-1.485-.645H443.43a2,2,0,0,0-1.973,2.026A2.013,2.013,0,0,0,443.415,293.467Z",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(436.457 289.468)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M443.415,301.314h12.371a2,2,0,0,0,1.469-3.355,2.027,2.027,0,0,0-1.485-.645H443.431a2,2,0,0,0-1.974,2.026A2.015,2.015,0,0,0,443.415,301.314Z",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(436.457 297.315)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M458.77,305.161H443.43a2,2,0,0,0-1.973,2.026,2.013,2.013,0,0,0,1.958,1.973h15.371a2,2,0,0,0,1.469-3.355A2.034,2.034,0,0,0,458.77,305.161Z",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(436.457 305.161)",
    fill: "#121e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburgerMenu.020e30ecfd0a59438f56503b4205ca67.svg";
export { ForwardRef as ReactComponent };